import Input from "components/form/Input";
import { Box, Flex, Stack } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { getvoidReturnFilteredData } from "../services/voidsReportServices";

export default function FilterModal({ onClose, data }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [filteredData, setFilteredData] = useState(data);

  // Filter Data
  const [filterCriteria, setFilterCriteria] = useState({
    BranchName: "",
    User: "",
    ProductName: "",
    Type: "",
  });

  const handleFilterVoidReturns = (e) => {
    e.preventDefault();

    const filteredResult = data.filter((item) => {
      const { User , BranchName , ProductName , Type} = filterCriteria;

      let filterUser = true;
      let filterType = true;
      let filterBranchName = true;
      let filterProductName = true;

      if (User) {
        filterUser = item?.User?.toLowerCase().includes(User.toLowerCase());
      }
      if (BranchName) {
        filterBranchName = item?.BranchName?.toLowerCase().includes(BranchName.toLowerCase());
      }
      if (ProductName) {
        filterProductName = item?.ProductName?.toLowerCase().includes(ProductName.toLowerCase());
      }
      if (Type) {
        filterType = item?.Type?.toLowerCase().includes(Type.toLowerCase());
      }

      return (
        filterUser &&
        filterType &&
        filterBranchName &&
        filterProductName 
         
      );

    });

    setFilteredData(filteredResult);
    onClose();
    dispatch(getvoidReturnFilteredData(filteredResult));
  };

  return  <>
      <GModal
        onClose={onClose}
        modalHeader={t("pages.reports.business_reports.filter")}
        modalContent={
          <Box p={4}>
            <form onSubmit={handleFilterVoidReturns}>
              <Stack spacing={6}>
                <Input
                  label={t("pages.reports.reports_tables.branch")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.branch")}
                  name="BranchName"
                  value={filterCriteria.BranchName}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      BranchName: e.target.value,
                    })
                  }
                />
                <Input
                  label={t("pages.reports.reports_tables.product")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.product")}
                  name="ProductName"
                  value={filterCriteria.ProductName}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      ProductName: e.target.value,
                    })
                  }
                />
                <Input
                  label={t("pages.reports.reports_tables.user")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.user")}
                  name="User"
                  value={filterCriteria.User}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      User: e.target.value,
                    })
                  }
                />
                <Input
                  label={t("pages.reports.reports_tables.type")}
                  labelStyle={{ textTransform: "capitalize" }}
                  placeholder={t("pages.reports.reports_tables.type")}
                  name="Type"
                  value={filterCriteria.Type}
                  onChange={(e) =>
                    setFilterCriteria({
                      ...filterCriteria,
                      Type: e.target.value,
                    })
                  }
                />

                <Flex gap={4}>
                  <GButton
                    type="submit"
                    title={t("general.save")}
                    bg="primary"
                    color="light"
                    border="1px solid transparent"
                    hover={{
                      color: "primary",
                      borderColor: "primary",
                      bg: "none",
                    }}
                  />
                  <GButton
                    title={t("general.close")}
                    onClick={onClose}
                    bg="red.600"
                    border="1px solid transparent"
                    color="light"
                    hover={{
                      color: "red.600",
                      borderColor: "red.600",
                      bg: "none",
                    }}
                  />
                </Flex>
              </Stack>
            </form>
          </Box>
        }
      />
    </>
};
